export default {
  'smartOrderingSettings.title': '扫码点餐',
  'smartOrderingSettings.QRCodeOrdering.title': '扫码点餐',
  'smartOrderingSettings.kioskOrdering.title': 'Kiosk点餐',
  'smartOrderingSettings.tabletOrdering.title': '平板点餐',
  'smartOrderingSettings.tabletOrdering.tabletPro.title': '平板点餐Pro版，提升点餐体验',
  'smartOrderingSettings.tabletOrdering.tabletPro.description':
    '打破中规中矩的常规菜单，让顾客享受在愉悦地点餐体验中，塑造品牌形象。',
  'smartOrderingSettings.tabletOrdering.tabletPro.subDescription':
    '请首先确认您使用的设备，针对不同屏幕比例需要单独设置模版。',
  'smartOrderingSettings.buffetOrdering.title': '自助餐点餐',
  'smartOrderingSettings.setupTables.secret': '二维码密钥',
  'smartOrderingSettings.setupTables.title': '为餐桌设置二维码',
  'smartOrderingSettings.setupRestaurant.title': '为餐厅设置二维码',
  'smartOrderingSettings.setUpQRCodes': '设置二维码',
  'smartOrderingSettings.setupTables.desc': '选择您要打印二维码的餐桌:',
  'smartOrderingSettings.takeout': '打印外带二维码',
  'smartOrderingSettings.incomingOrders.title': 'QR来单设置',
  'smartOrderingSettings.acceptQRCodeOrders': '接受扫码点餐来单',
  'smartOrderingSettings.payment.desc': '选择接受的结帐方式：',
  'smartOrderingSettings.acceptDineInOrders': '接受堂食订单',
  'smartOrderingSettings.enableSwitchTable': '允许切换桌台',
  'smartOrderingSettings.allowDinersToAddDishesThroughQRCodeToWalkInOrders': '允许客人通过扫码对到店点餐的订单进行加菜',
  'smartOrderingSettings.allowDinersToAddDishesThroughQRCodeToWalkInOrders.description':
    '对QRCode和Tablet Ordering都生效',
  'smartOrderingSettings.addAPrefixInTicketNum': '订单号增加前缀',
  'smartOrderingSettings.addAPrefixInTicketNum.description': '对QRCode和Tablet Ordering都生效',

  'smartOrderingSettings.sortDishesDynamicallyBySales': '根据销量对分类内的菜品动态排序',
  'smartOrderingSettings.webPageSetting.displayForeignNames': '显示菜品中文名',
  'smartOrderingSettings.dineInOrders.fullService.onlinePayment': '线上支付（点餐后支付）和线下支付结合',
  'smartOrderingSettings.dineInOrders.quickService.onlinePayment': '线上支付（即刻付清）',
  'smartOrderingSettings.dineInOrders.offlinePayment': '线下支付',
  'smartOrderingSettings.dineInOrders.fullService.onlinePaymentImmediately': '线上支付（即刻付清）',
  'smartOrderingSettings.acceptToGoOrders': '接受外带订单',
  'smartOrderingSettings.togoOrders.onlinePayment': '线上支付（即刻付清）',
  'smartOrderingSettings.togoOrders.offlinePayment': '线下支付',
  'smartOrderingSettings.webPageSetting.title': 'QR扫码点餐设置',
  'smartOrderingSettings.webPageSetting.displayDishRatings': '显示菜品评分',
  'smartOrderingSettings.webPageSetting.displayChowbusCategories': '显示Chowbus置顶分类',
  'smartOrderingSettings.webPageSetting.displayChowbusCategories.description': '包括新品尝鲜/人气热卖',
  'smartOrderingSettings.webPageSetting.displayDishForeignNames': '显示菜品中文名',
  'smartOrderingSettings.webPageSetting.displaySoldoutDishesAndCustomizations': '显示售罄菜品和附加选项',
  'smartOrderingSettings.webPageSetting.askGuestNumber': '询问客人数量',
  'smartOrderingSettings.webPageSetting.askGuestPhone': '询问客人电话',
  'smartOrderingSettings.webPageSetting.requestToVerifyGuestPhone': `堂食手机号验证`,
  'smartOrderingSettings.webPageSetting.enableOrderLevelNotes': `允许整单备注(堂食单)`,
  'smartOrderingSettings.webPageSetting.enableOrderLevelNotesForTakeout': `允许整单备注(外带单)`,
  'smartOrderingSettings.webPageSetting.enableMealLevelNotes': `允许菜品备注(外带单)`,
  'smartOrderingSettings.webPageSetting.enableMealLevelNotesForDinein': `允许菜品备注(堂食单)`,
  'smartOrderingSettings.webPageSetting.enableMealLevelNotes.description': '目前仅对外带单生效',
  'smartOrderingSettings.enableLoyaltyBalancePayment': `整单支付时，允许使用会员余额支付`,
  'smartOrderingSettings.webPageSetting.enableGuestEditReceiptPhoneNumber': '显示输入/修改手机号功能',
  'smartOrderingSettings.webPageSetting.enableGuestReceiptEmail': '显示输入/修改电子邮箱功能',

  'smartOrderingSettings.togoOrders.onlinePayment.SMS.support': '下单后发送短信（含电子收据）',
  'smartOrderingSettings.togoOrders.onlinePayment.SMS.notSupport': '不发送短信',
  'smartOrderingSettings.dineInOrders.onlinePaymentImmediatrly.SMS.support': '下单后发送短信（含电子收据）',
  'smartOrderingSettings.dineInOrders.onlinePaymentImmediatrly.SMS.notSupport': '不发送短信',

  'smartOrderingSettings.column.section': '区域',
  'smartOrderingSettings.column.table': '桌名',
  'smartOrderingSettings.column.enabled': '是否开启扫码点餐',
  'smartOrderingSettings.action.selectAll': '全选',
  'smartOrderingSettings.action.clear': '清空',
  'smartOrderingSettings.action.desc': '选择您要打印二维码的类型:',
  'smartOrderingSettings.action.downloadStand': '立牌二维码',
  'smartOrderingSettings.action.downloadSticker': '贴纸二维码',
  'smartOrderingSettings.restaurantLevel.action.downloadStand': '外带立牌二维码',
  'smartOrderingSettings.restaurantLevel.action.downloadSticker': '外带贴纸二维码',
  'smartOrderingSettings.action.generateCheckCode': '生成',
  'smartOrderingSettings.action.regenerateCheckCode': '重新生成',

  'smartOrderingSettings.regenerateCheckCode.prompt':
    '是否需要重新生成二维码密钥？重新生成后原二维码将作废，餐厅需要重新打印所有桌子的二维码。出于安全需要，在原二维码泄露时，建议重新生成密钥。',
  'smartOrderingSettings.noSecret': '下载前请先生成二维码密钥',

  'smartOrderingSettings.downloading': '正在生成PDF',
  'smartOrderingSettings.downloadingA5': '正在生成PDF ({count}/{total})',
  'smartOrderingSettings.cancelDownloading': '放弃下载',

  'smartOrderingSettings.generate.prompt': '只有餐厅老板才能生成二维码密钥',
  'smartOrderingSettings.regenerate.prompt': '只有餐厅老板才能重新生成二维码密钥',

  'smartOrderingSettings.restaurantList': '餐厅列表',
  'smartOrderingSettings.restaurantList.filter': '搜索名称/中文名/餐厅id',
  'smartOrderingSettings.generateQRCodes': '生成二维码',

  'smartOrderingSettings.QRCode.poster.size.selction.desc': '请选择要打印的二维码尺寸:',
  'smartOrderingSettings.QRCode.poster.size.Stand': '立牌',
  'smartOrderingSettings.QRCode.poster.size.Sticker': '桌贴',
  'smartOrderingSettings.QRCode.poster.size.AcrylicSheets': '亚克力板',
  'smartOrderingSettings.QRCode.poster.size.5x8_inch_Stand': '5" x 8"',
  'smartOrderingSettings.QRCode.poster.size.4x6_inch_Sticker': '4" x 6"',
  'smartOrderingSettings.QRCode.poster.size.4x4_inch_Sticker': '4" x 4"',
  'smartOrderingSettings.QRCode.poster.size.250x250_inch_Sticker': '2.5" x 2.5"',

  'smartOrderingSettings.QRCode.poster.size.A5_Stand': 'A5',
  'smartOrderingSettings.QRCode.poster.size.3x3_cm_Sticker': '3.3 x 3.3 cm',
  'smartOrderingSettings.QRCode.poster.size.325x325_inch_Sticker': '3.25" x 3.25"',

  'smartOrderingSettings.QRCode.action.download': '下载二维码',
  'smartOrderingSettings.QRCode.action.takout.download': '下载外带二维码',

  'smartOrderingSettings.tabletOrderingSetting.title': '平板点餐设置',
  'smartOrderingSettings.tabletOrderingSetting.unlockMenusByPIN': '是否需要服务员解锁菜单',
  'smartOrderingSettings.tabletOrderingSetting.unlockMenusByPIN.description':
    '仅支持多套菜单的平板点餐，在解锁时需要验证服务员PIN码',
  'smartOrderingSettings.tabletOrderingSetting.unlockMenusByPIN.tips':
    '开启后：手机扫码将只能查看菜单，不能下单；kiosk将显示全部菜单并支持下单',

  'smartOrderingSettings.tabletOrderingSetting.inputGuestNumber': '输入用餐人数',
  'smartOrderingSettings.tabletOrderingSetting.inputGuestNumber.description': '输入用餐人数时需要验证服务员PIN码',

  'smartOrderingSettings.tabletOrderingSetting.enableOrderLevelNotes': '允许整单备注',
  'smartOrderingSettings.tabletOrderingSetting.enableMealLevelNotes': '允许菜品备注',

  'smartOrderingSettings.tabletOrderingSetting.unlockPIN': '设置解锁PIN码',
  'smartOrderingSettings.tabletOrderingSetting.unlockPIN.edit': '编辑',
  'smartOrderingSettings.tabletOrderingSetting.unlockPIN.edit.title': '更新解锁PIN码',
  'smartOrderingSettings.tabletOrderingSetting.unlockPIN.label': 'PIN码',
  'smartOrderingSettings.tabletOrderingSetting.unlockPIN.isrequired': '请输入PIN码',
  'smartOrderingSettings.tabletOrderingSetting.unlockPIN.must4digit': 'PIN Code必须是4位数字',
  'smartOrderingSettings.webPageSetting.enableCustomizationLimitProperties': '使用附加选项和菜品偏好的限制规则',
  'smartOrderingSettings.webPageSetting.enableCustomizationLimitProperties.description':
    '开启后，将应用附加选项、菜品偏好的各项限制规则',

  'smartOrderingSettings.tabletOrderingSetting.buffetOrderingLimit': '自助点餐限制',
  'smartOrderingSettings.tabletOrderingSetting.buffetOrderingLimit_new_guide_front': '已移至新页面，请',
  'smartOrderingSettings.tabletOrderingSetting.buffetOrderingLimit_new_guide_end': '点击此处前往 >>',
  'smartOrderingSettings.tabletOrderingSetting.shoppingCartLimit': '提交购物车限制',
  'smartOrderingSettings.tabletOrderingSetting.buffetOrderingLimit.description':
    '仅对tablet生效,QR将进入菜单浏览模式,禁止加购和提交',
  'smartOrderingSettings.tabletOrderingSetting.limitByGuest': '按用餐人数限制菜品购买数量',

  'smartOrderingSettings.tabletOrderingSetting.maxItemsOnOrder': '每人点餐总份数限制',
  'smartOrderingSettings.tabletOrderingSetting.maxItemsOnOrder.rule': '请填写每人点餐总份数限制(必填)!',
  'smartOrderingSettings.tabletOrderingSetting.maxItemsOnOrderAddonAfter': '份/人',

  'smartOrderingSettings.tabletOrderingSetting.diningTimeLimit': '按用餐时长限制',
  'smartOrderingSettings.tabletOrderingSetting.diningTimeLimit.rule': '请填写用餐时长限制(必填)!',
  'smartOrderingSettings.tabletOrderingSetting.diningTimeLimitAddonAfter': '分钟/单',

  'smartOrderingSettings.webPageSetting.applyPreferences': '应用菜品偏好',
  'smartOrderingSettings.webPageSetting.applyPreferences.des': '为保障订单数据一致，QR点餐和平板点餐将联动开启',

  'smartOrderingSettings.tabletOrderingSetting.countdownReminder': '用餐时长倒计时提醒',
  'smartOrderingSettings.tabletOrderingSetting.countdownReminder.rule': '请填写餐时长倒计时提醒(必填)!',
  'smartOrderingSettings.tabletOrderingSetting.countdownReminderAddonAfter': '分钟',

  'smartOrderingSettings.tabletOrderingSetting.submitRoundsInterval': '限制两次提交间隔',
  'smartOrderingSettings.tabletOrderingSetting.submitRoundsInterval.rule': '请填写提交购物车频率限制(必填)!',
  'smartOrderingSettings.tabletOrderingSetting.submitRoundsIntervalAddonAfter': '分钟/提交',

  'smartOrderingSettings.tabletOrderingSetting.maxRoundsPerOrder': '限制提交总次数',
  'smartOrderingSettings.tabletOrderingSetting.maxRoundsPerOrder.rule': '请填写提交购物车次数限制(必填)!',
  'smartOrderingSettings.tabletOrderingSetting.maxRoundsPerOrderAddonAfter': '次/单',

  'smartOrderingSettings.tabletOrderingSetting.editLimitRule': '编辑限购规则',
  'smartOrderingSettings.tabletOrderingSetting.chooseLimitQuantity': '选择限购份数',
  'smartOrderingSettings.tabletOrderingSetting.chooseLimitType': '选择限购方式',
  'smartOrderingSettings.tabletOrderingSetting.chooseLimitItems': '选择限购商品',
  'smartOrderingSettings.tabletOrderingSetting.chooseLimitCategorys': '选择限购分类',

  'smartOrderingSettings.tabletOrderingSetting.needMaxItemsPerRound': '限制单次提交份数',
  'smartOrderingSettings.tabletOrderingSetting.needMaxItemsPerRoundAddonAfter': '份数',

  'smartOrderingSettings.tabletOrderingSetting.enableScreenSaver': '点餐屏保',
  'smartOrderingSettings.tabletOrderingSetting.enableScreenSaver.description': '关闭后，tablet点餐会一直停留在点餐页面',

  'smartOrderingSettings.tabletOrderingSetting.originalPriceStrikethrough': '原价划线',
  'smartOrderingSettings.tabletOrderingSetting.originalPriceStrikethrough.description': `关闭后，有会员价的菜，原价不划线`,
  'smartOrderingSettings.webPageSetting.browsingMenuModeForce': '菜单浏览模式',
  'smartOrderingSettings.webPageSetting.browsingMenuModeForce.description':
    '菜单浏览模式开启后只对手机扫码点餐生效,平板点餐不受影响',

  'smartOrderingSettings.QRCode.action.menubrowsing.download': '下载菜单浏览二维码',

  'smartOrderingSettings.tabletOrderingSetting.enableShowTotalPriceOnSubmitButton': '平板点餐购物车内显示总价',
  'smartOrderingSettings.tabletOrderingSetting.enableShowTotalPriceOnSubmitButton.description': `关闭后，提交按钮旁不显示当前购物车总价`,

  'smartOrderingSettings.tabletOrderingSetting.showQRCode': '平板点餐显示点餐二维码',
  'smartOrderingSettings.tabletOrderingSetting.showQRCode.description': `关闭后，平板上不显示点餐二维码`,

  'smartOrderingSettings.webPageSetting.mealImageShowStyle': `菜单展示样式`,
  'smartOrderingSettings.webPageSetting.mealImageShowStyle.default': '默认(首道菜图片自动放大)',
  'smartOrderingSettings.webPageSetting.mealImageShowStyle.medium': '中图(首道菜图片不放大)',
  'smartOrderingSettings.webPageSetting.mealImageShowStyle.description':
    '菜单展示样式只对手机扫码点餐生效,平板点餐不受影响',

  'smartOrderingSettings.tabs.qrcode-download': '二维码下载',
  'smartOrderingSettings.tabs.qrcode-tablet-ordering-setting': '手机扫码 / 平板点餐设置',
  // 'smartOrderingSettings.tabs.tablet-ordering-setting': '平板点餐设置',
  'smartOrderingSettings.tabs.kiosk-ordering-setting': 'Kiosk点餐设置',
  'smartOrderingSettings.tabs.qrcode-tablet-ordering-setting.qrcode': '手机扫码设置',
  'smartOrderingSettings.tabs.qrcode-tablet-ordering-setting.tablet': '平板点餐设置',

  'smartOrderingSettings.qrcode-tablet-ordering-setting.qrcode.incomingOrders.title': '来单设置',
  'smartOrderingSettings.qrcode-tablet-ordering-setting.tablet.incomingOrders.title': '来单设置',
  'smartOrderingSettings.kiosk-ordering-setting.incomingOrders.title': '来单设置',

  'smartOrderingSettings.tablet.dineInEnable.description': '关闭后,手机扫码端的堂食订单也将被关闭',
  'smartOrderingSettings.kiosk.webPageSetting.title': '展示设置',
  'smartOrderingSettings.qrcode.webPageSetting.title': '展示设置',
  'smartOrderingSettings.tablet.webPageSetting.title': '展示设置',

  'smartOrderingSettings.tablet.dineIn.error': '手机扫码堂食支付方式即刻付清-平板堂食不可设置',
  'smartOrderingSettings.qrcode.dineIn.paymentImmediately.error': '不能支持即刻付清-tablet 堂食打开的情况下',

  'smartOrderingSettings.webPageSetting.payInStore': '到柜台支付',
  'smartOrderingSettings.webPageSetting.payInStore.description': '打开到柜台支付开关，必须设置支付成功后再出厨房小票',

  'smartOrderingSettings.tabletOrderingSetting.modalAdd': '+ 新增限购商品',
  'smartOrderingSettings.tabletOrderingSetting.deleteLimitRow': '删除',
  'smartOrderingSettings.tabletOrderingSetting.editLimitRow': '编辑',
  'smartOrderingSettings.tabletOrderingSetting.limitItemTitle': '限购商品',
  'smartOrderingSettings.tabletOrderingSetting.addModalTitle': '选择限购的商品',
  'smartOrderingSettings.tabletOrderingSetting.setModalTitle': '设置限购份数',
  'smartOrderingSettings.tabletOrderingSetting.modalCancel': '取消',
  'smartOrderingSettings.tabletOrderingSetting.modalBack': '返回',
  'smartOrderingSettings.tabletOrderingSetting.modalNext': '下一步',
  'smartOrderingSettings.tabletOrderingSetting.modalSave': '保存',
  'smartOrderingSettings.tabletOrderingSetting.customQuantity': '自定义份数',
  'smartOrderingSettings.tabletOrderingSetting.itemPer': '份/人',
  'smartOrderingSettings.tabletOrderingSetting.perGuest': '每人',
  'smartOrderingSettings.tabletOrderingSetting.chooseMeals': '请选择菜品',
  'smartOrderingSettings.tabletOrderingSetting.qrcodeSetting': '二维码下载',
  'smartOrderingSettings.tabletOrderingSetting.qrSetting': 'QR设置',
  'smartOrderingSettings.tabletOrderingSetting.tabletSetting': '平板点餐设置',
  'smartOrderingSettings.tabletOrderingSetting.kioskSetting': 'Kiosk点餐设置',
  'smartOrderingSettings.tabletOrderingSetting.saveChangeBtn': '保存',
  'smartOrderingSettings.tabletOrderingSetting.discardBtn': '取消',
  'smartOrderingSettings.tabletOrderingSetting.limitTableProductTitle': '商品',
  'smartOrderingSettings.tabletOrderingSetting.limitTablePerGuestTitle': '限购数量/人',
  'smartOrderingSettings.tabletOrderingSetting.limitTableOperationTitle': '操作',
  'smartOrderingSettings.update.success': '更新智能点餐设置成功',
  'smartOrderingSettings.update.fail': '更新智能点餐设置失败',
  'smartOrderingSettings.tabletOrderingSetting.displayCountdownReminder.validator':
    '倒计时提醒时间必须小于或者等于用餐时间!',
  'smartOrderingSettings.tabletOrderingSetting.diningTimeLimit.validator': '用餐时间必须大于等于倒计时提醒时间!',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byCategory': '每个分类限购N份',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byCategory.table': '每个分类限购',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byCategory.desc':
    '选择要限制的分类，每个所选分类下的菜品，限制顾客最多可购买N份',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byDish': '每种菜品限购N份',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byDish.table': '每种菜品限购',
  'smartOrderingSettings.tabletOrderingSetting.limit.type.byDish.desc':
    '选择要限制的菜品，每一种所选菜品，单独限制顾客最多可购买N份',
  'smartOrderingSettings.tabletOrderingSetting.limit.mustChooseLimitType': '请选择限购方式',
  'smartOrderingSettings.tabletOrderingSetting.limit.mustChooseLimitQuantity': '请选择限购份数',
  'smartOrderingSettings.tabletOrderingSetting.limit.mustChooseLimitItem': '请选择限购商品',
  'smartOrderingSettings.tabletOrderingSetting.limit.mustChooseLimitCategory': '请选择限购分类',
  'smartOrderingSettings.tabletOrderingSetting.limit.selectAll': '全选',
  'smartOrderingSettings.tabletOrderingSetting.limit.limitType': '限购方式',
  'smartOrderingSettings.tabletOrderingSetting.limit.limitItemOrCategory': '限购菜品/分类',
  'smartOrderingSettings.tabletOrderingSetting.limit.only_items': '限购菜品',
  'smartOrderingSettings.tabletOrderingSetting.limit.limitQuantity': '限购数量',
  'smartOrderingSettings.tabletOrderingSetting.limit.limitItemsPerRound':
    '按用餐人数限制的菜品，在提交购物车时不做限制.',
  'smartOrderingSettings.tabletOrderingSetting.limit.limitItemsPerRound.tooltip':
    '例如：设置菜品A限制每人限点1份，同时设置购物车单次可提交10份，在提交购物车时菜品A不算入10份之内。',
  'smartOrderingSettings.tabletOrderingSetting.limit.tableNoData': '暂未选择限购商品',
  'smartOrderingSettings.tabletOrderingSetting.notSupportTablePro':
    '您尚未购买 <span>平板点餐Pro版</span> 服务，请联系Chowbus销售代表订购服务。',
  'smartOrderingSettings.tabletOrderingSetting.showItemCategory': '显示菜品分类',
  'smartOrderingSettings.tabletOrderingSetting.showItemCategoryTips': '开启后，将按菜品分类对页面分组。',
  'smartOrderingSettings.tabletOrderingSetting.showItemCategoryGuide': '开启后，Tablet端效果示例：',
  'smartOrderingSettings.tabletOrderingSetting.showCategoryTurnOn': '显示',
  'smartOrderingSettings.tabletOrderingSetting.showCategoryTurnOff': '不显示',
  'smartOrderingSettings.tabletOrderingSetting.ordering_mode_required_warn_title': '请选择点餐模式',
  'smartOrderingSettings.tabletOrderingSetting.ordering_mode_required_warn_desc': '如不需 Tablet Pro，请关闭开关',
  'smartOrderingSettings.tabletOrderingSetting.ordering_mode_required_warn_confirm_text': '返回修改',
  'smartOrderingSettings.tabletOrderingSetting.searchScope': '搜索范围',
  'smartOrderingSettings.tabletOrderingSetting.searchScopeOnly': '仅搜索装修方案中包含的菜品',
  'smartOrderingSettings.tabletOrderingSetting.searchScopeAll': '搜索平板点餐全部菜品',

  // buffet
  'smartOrderingSettings.buffet_ordering.title': '自助餐点餐解决方案，让您的门店营运更加高效',
  'smartOrderingSettings.buffet_ordering.description':
    '通过灵活的点餐规则，为您的顾客提供更优的就餐体验，减轻服务员工作压力。自助餐点餐限制规则，可适用于扫码点餐、平板点餐。两端同步使用时，请先确保菜单的“可见渠道”设置一致。',
  'smartOrderingSettings.buffet_ordering.restrictions': '自助餐点餐限制规则',
  'smartOrderingSettings.buffet_ordering.restrictions_extra':
    '开启后，平板点餐/扫码点餐将进入自助餐点餐模式，请在此页面中设置点餐限制规则。',
  'smartOrderingSettings.buffet_ordering.apply_to': '规则适用范围',
  'smartOrderingSettings.buffet_ordering.apply_to_extra':
    '在平板点餐和扫码点餐中，只选择一端时，另一端将进入菜单浏览模式，不能加购和提交。',
  'smartOrderingSettings.buffet_ordering.apply_to_qr': '扫码点餐',
  'smartOrderingSettings.buffet_ordering.apply_to_tablet': '平板点餐',
  'smartOrderingSettings.buffet_ordering.input_guest_number': '服务员输入人数',
  'smartOrderingSettings.buffet_ordering.input_guest_number_extra':
    '在用餐前由服务员输入人数，以方便收费。输入时需要验证服务员PIN码。',
  'smartOrderingSettings.buffet_ordering.radio_input_guest_number': '输入人数',
  'smartOrderingSettings.buffet_ordering.radio_input_guest_number_no_need': '不需输入',
  'smartOrderingSettings.buffet_ordering.unlock_menu_restrictions': '菜单限制',
  'smartOrderingSettings.buffet_ordering.unlock_menu_restrictions_extra':
    '如果有多个不同价位，对应不同的菜单，请在这里设置。此处选中的菜单，需要服务员选定，并验证服务员PIN码。',
  'smartOrderingSettings.buffet_ordering.time_limits': '用餐时长限制',
  'smartOrderingSettings.buffet_ordering.dining_time_input_rule': '请填写用餐时长(必填)!',
  'smartOrderingSettings.buffet_ordering.time_limits_extra':
    '如果需要限制客人的用餐时长，请在这里设置。还可在用餐时间快到时，显示倒计时提醒。',
  'smartOrderingSettings.buffet_ordering.dining_time': '限制时长',
  'smartOrderingSettings.buffet_ordering.dining_time_input_afteraddon': '分钟/单',
  'smartOrderingSettings.buffet_ordering.timer': '用餐时长倒计时提醒',
  'smartOrderingSettings.buffet_ordering.timer_input_rule': '请填写用餐时长倒计时提醒(必填)!',
  'smartOrderingSettings.buffet_ordering.timer_input_afteraddon': '分钟',
  'smartOrderingSettings.buffet_ordering.timer_show_timer': '设置限制规则',
  'smartOrderingSettings.buffet_ordering.timer_hide_timer': '不限制',
  'smartOrderingSettings.buffet_ordering.item_limits_per_guest': '按每人限制',
  'smartOrderingSettings.buffet_ordering.item_limits_per_guest_extra':
    '如果有部分菜品或分类，需要限制每人点餐的数量，或限制每人点餐的总数量，请在这里设置。',
  'smartOrderingSettings.buffet_ordering.limit_item_purchase_quantities_by_guest': '	按每人限制菜品点餐数量',
  'smartOrderingSettings.buffet_ordering.limit_item_purchase_quantities_by_guest.set_limits': '设置限制规则',
  'smartOrderingSettings.buffet_ordering.limit_item_purchase_quantities_by_guest.no_limits': '不限制',
  'smartOrderingSettings.buffet_ordering.overall_limits_for_the_entire_order': '每人点餐总份数限制',
  'smartOrderingSettings.buffet_ordering.overall_limits_for_the_entire_order.rule': '请填写每人点餐总份数限制(必填)!',
  'smartOrderingSettings.buffet_ordering.overall_limits_for_the_entire_order.set_limit': '设置限制规则',
  'smartOrderingSettings.buffet_ordering.overall_limits_for_the_entire_order.no_limit': '不限制',
  'smartOrderingSettings.buffet_ordering.overall_limits_for_the_entire_order.input_afteraddon': '份/人',
  'smartOrderingSettings.buffet_ordering.shopping_cart_limit': '提交购物车限制',
  'smartOrderingSettings.buffet_ordering.shopping_cart_limit.extra':
    '如果需要对提交购物车的动作进行限制，比如限制每次提交的菜品数量、两次提交的时间间隔等，请在这里设置。',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit': '限制单次提交份数',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_rule': '请填写限制单次提交份数(必填)!',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_all': '全部菜品都限制',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_by_guest':
    '按用餐人数限制的菜品，在提交购物车时不做限制',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_by_guest_desc':
    '例如：设置菜品A限制每人限点1份，同时设置购物车单次可提交10份，在提交购物车时菜品A不算入10份之内。',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_some': '只限制部分菜品',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_no': '不限制',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_greater_than_zero': '数值必须大于0',
  'smartOrderingSettings.buffet_ordering.max_items_per_round_limit_input_afteraddon': '份/次',
  'smartOrderingSettings.buffet_ordering.submit_rounds_interval': '限制两次提交间隔',
  'smartOrderingSettings.buffet_ordering.submit_rounds_interval.rule': '请填写提交购物车频率限制(必填)!',
  'smartOrderingSettings.buffet_ordering.submit_rounds_interval_set_limits': '设置限制规则',
  'smartOrderingSettings.buffet_ordering.submit_rounds_interval_no_limit': '不限制',
  'smartOrderingSettings.buffet_ordering.submit_rounds_interval_input_afteraddon': '分钟/提交',
  'smartOrderingSettings.buffet_ordering.max_rounds_per_order': '限制提交总次数',
  'smartOrderingSettings.buffet_ordering.max_rounds_per_order.rule': '请填写提交购物车次数限制(必填)!',
  'smartOrderingSettings.buffet_ordering.max_rounds_per_order_set_limits': '设置限制规则',
  'smartOrderingSettings.buffet_ordering.max_rounds_per_order_no_limit': '不限制',
  'smartOrderingSettings.buffet_ordering.max_rounds_per_order_input_afteraddon': '次/单',
  'smartOrderingSettings.buffet_ordering.per_guest_warn_title': '请设置按每人限制规则',
  'smartOrderingSettings.buffet_ordering.per_guest_warn_desc': '如不需按每人限制，请关闭该项开关',
  'smartOrderingSettings.buffet_ordering.per_guest_warn_confirm_text': '返回修改',
  'smartOrderingSettings.buffet_ordering.menu_limit_warn_title': '请设置菜单限制规则',
  'smartOrderingSettings.buffet_ordering.menu_limit_warn_desc': '如不需菜单限制，请关闭该项开关',
  'smartOrderingSettings.buffet_ordering.menu_limit_warn_confirm_text': '返回修改',
  'smartOrderingSettings.buffet_ordering.cart_limit_warn_title': '请设置提交购物车限制规则',
  'smartOrderingSettings.buffet_ordering.cart_limit_warn_desc': '如不需按每人限制，请关闭该项开关',
  'smartOrderingSettings.buffet_ordering.cart_limit_warn_confirm_text': '返回修改',
  'smartOrderingSettings.buffet_ordering.load_failed': '加载失败，',
};
